import { FC, memo } from "react";
import { useField } from "formik";
import { TextField, TextFieldProps } from "@mui/material";
import { InputProps } from "./type";
import styles from "./styles";
import { setIsFormUpdated } from "../../../redux/global.slice";
import { useAppDispatch } from "../../../hooks/useAppDispatch";

const Input: FC<InputProps & TextFieldProps> = ({
  name,
  label,
  placeholder,
  externalStyles = {},
  isRequired = false,
  onChange,
  isBlockNavigation = false,
  ...otherProps
}) => {
  const [field, meta] = useField(name);
  const dispatch = useAppDispatch();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (field.onChange) field.onChange(event);
    if (onChange) onChange(event);
    if (isBlockNavigation) dispatch(setIsFormUpdated(true));
  };

  const attributes: TextFieldProps = {
    ...field,
    ...otherProps,
    label: `${label ?? placeholder}${isRequired ? "*" : ""}`,
    error: meta.touched && Boolean(meta.error),
    helperText: meta.touched && meta.error,
    sx: [styles.authInput, externalStyles],
    type: otherProps.type ?? "text",
    placeholder,
    onChange: handleChange,
  };

  return <TextField {...attributes} />;
};

export default memo(Input);
